import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// ✅ 최대 캐시 개수
const MAX_CACHE = 200;

// 중복 제거 기준 키(파일 경로가 유니크하다고 가정)
const keyOf = (r) => r?.image_path || r?.id || JSON.stringify(r);

// ✅ 앞쪽(최신) 우선 유지: 중복 제거 + MAX_CACHE로 슬라이스
function dedupAndClamp(list) {
    const seen = new Set();
    const out = [];
    for (const it of list) {
        const k = keyOf(it);
        if (seen.has(k)) continue;
        seen.add(k);
        out.push(it);
        if (out.length >= MAX_CACHE) break;
    }
    return out;
}

export const useRecordsStore = create(
    persist(
        (set, get) => ({
            records: [],
            lastFetchedAt: undefined, // Date.now()

            // 서버에서 최신 목록을 가져와 통째로 교체(초기 구동/리프레시)
            setRecords: (list = []) => {
                set({
                    records: dedupAndClamp(list),
                    lastFetchedAt: Date.now(),
                });
            },

            // 업로드 성공 시 즉시 반영(맨 앞 upsert 후 상한 적용)
            addRecord: (item) => {
                if (!item) return;
                const k = keyOf(item);
                set((s) => {
                    const next = [item, ...s.records.filter((r) => keyOf(r) !== k)];
                    return { records: dedupAndClamp(next) };
                });
            },

            // 여러 개를 한꺼번에 반영(옵션)
            upsertRecords: (items = []) => {
                const cur = get().records;
                // 새 항목을 앞에 둬서 최근 것을 우선 보존
                const combined = [...items, ...cur];
                set({ records: dedupAndClamp(combined) });
            },

            clearRecords: () => set({ records: [], lastFetchedAt: undefined }),
        }),
        {
            name: "wm-records-cache",
            storage: createJSONStorage(() => localStorage),
            partialize: (s) => ({
                records: s.records,
                lastFetchedAt: s.lastFetchedAt,
            }),
        }
    )
);
